import createISODateWithGermanTimezone from "scripts/createISODateWithGermanTimezone"
import doenerCase from "scripts/doenerCase"

export const createBfzArticleSchemaOrgData = ({
  article_body,
  breadcrumb_array,
  article_date,
  human_authors,
  seo_title,
  last_update,
  location,
  meta_description,
  organization_authors,
  related_article_links,
  schema_org_image_array,
}) => {
  const all_authors = [...human_authors, ...organization_authors]

  const sd_authors = all_authors.map((author) => {
    return {
      "@type": author?.type || "Organization",
      name: author?.name || "B_I MEDIEN",
      url: !!author?.strapi_data
        ? `https://bi-medien.de/ueber-uns/redaktion/${doenerCase(author.name)}`
        : undefined,
      sameAs: !!author?.strapi_data
        ? [
            author?.strapi_data?.facebook,
            author?.strapi_data?.linkedIn,
            author?.strapi_data?.twitter,
            author?.strapi_data?.xing,
          ].filter((profile) => !!profile)
        : undefined,
    }
  })

  const article_schema_org_data = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `https://bi-medien.de${location.pathname}`,
      relatedLink: related_article_links[0] ? related_article_links : undefined,
    },
    headline: seo_title,
    description: meta_description + " ► Mehr erfahren!",
    image: schema_org_image_array,
    datePublished: createISODateWithGermanTimezone(article_date),
    dateModified: last_update
      ? createISODateWithGermanTimezone(last_update)
      : undefined,
    author: !!sd_authors?.[0]
      ? sd_authors
      : {
          "@type": "Organization",
          name: "B_I MEDIEN",
        },
    publisher: {
      "@type": "Organization",
      name: "B_I MEDIEN",
      logo: {
        "@type": "ImageObject",
        url: `https://bi-medien.de/assets/b-i-medien-publisher-logo.png`,
      },
    },
    articleBody: article_body,
  }

  const breadcrumb_schema_org_data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumb_array.map((breadcrumb_item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: breadcrumb_item.content,
      item:
        breadcrumb_item.type === "BreadcrumbLink"
          ? `https://bi-medien.de${breadcrumb_item.link}`
          : `https://bi-medien.de${location.pathname}`,
    })),
  }

  return [article_schema_org_data, breadcrumb_schema_org_data]
}
